// Tab order — the pure half of dragging a tab sideways to a new place
// (TabBar.jsx drags, TabContext.jsx moveTab applies).
//
// No React, no DOM: the runner checks these directly.

// Move the tab `id` so it lands before the tab now at `toIndex` (0..length;
// `length` = the end). Returns the same array when nothing moves, so a drop
// on the tab's own spot does not re-render or re-save the tab set.
export function reorderTabs(tabs, id, toIndex) {
  const from = tabs.findIndex((t) => t.id === id);
  if (from < 0) return tabs;
  const to = Math.max(0, Math.min(tabs.length, toIndex));
  if (to === from || to === from + 1) return tabs;
  const next = tabs.slice();
  const [moved] = next.splice(from, 1);
  next.splice(to > from ? to - 1 : to, 0, moved);
  return next;
}

// Where a drop at x lands: the index of the first tab whose middle is right
// of x, or the end. `rects` are the tabs' {left, width} in bar order.
export function dropIndexAt(rects, x) {
  for (let i = 0; i < rects.length; i += 1) {
    if (x < rects[i].left + rects[i].width / 2) return i;
  }
  return rects.length;
}
